<template>
  <new-modal-dialog
    :title="$t('label.feedback')"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @close="emit('close')"
  >
    <contact-message-dialog
      v-if="messageDialog && feedback.reservation"
      visible
      :reservation="feedback.reservation"
      :feedback-id="feedback.id"
      @close="closeMessageDialog"
    />
    <v-row>
      <v-col
        cols="6"
        class="pb-0 pt-6"
      >
        <v-text-field
          :value="$localized.numericDateTimeText(feedback.created)"
          :label="$t('label.date_of_feedback')"
          readonly
        />
      </v-col>
      <v-col
        cols="6"
        class="pb-0 pt-6"
      >
        <v-text-field
          :value="$localized.numericDateTimeText(feedback.reservationDtBegin)"
          :label="$t('label.date_of_visit')"
          readonly
        />
      </v-col>
      <v-col
        cols="12"
        class="py-0"
      >
        <v-text-field
          :value="reservation?.contact.name"
          :label="$t('label.person_name')"
          readonly
        />
      </v-col>
      <v-col
        cols="12"
        class="mb-2"
      >
        <v-divider class="py-2" />

        {{ $t('label.rating_general') }}:
        <v-rating
          color="yellow"
          background-color="grey"
          readonly
          large
          :label="$t('label.rating_general')"
          dense
          :value="feedback.overallRating"
        />
        <v-divider class="mb-2 mt-4" />
      </v-col>
      <template v-if="true">
        <v-col
          cols="4"
          class="py-0"
        >
          {{ $t('label.rating_food') }}:
          <feedback-rating-chip
            :value="feedback.foodRating"
            class="ml-6"
          />
        </v-col>
        <v-col
          cols="4"
          class="py-0"
        >
          {{ $t('label.rating_service') }}:
          <feedback-rating-chip
            :value="feedback.serviceRating"
            class="ml-6"
          />
        </v-col>
        <v-col
          cols="4"
          class="py-0"
        >
          {{ $t('label.rating_ambience') }}:
          <feedback-rating-chip
            :value="feedback.ambienceRating"
            class="ml-6"
          />
        </v-col>
      </template>
      <v-col
        cols="12"
        class="mt-4"
      >
        <v-divider class="pb-4 " />
        <v-textarea
          :label="$t('label.comments')"
          readonly
          :value="feedback.comments"
        />
      </v-col>
    </v-row>
    <template #actions>
      <v-btn
        :disabled="feedback.replied || (!reservation?.contact.email && !reservation?.contact.phone)"
        color="primary"
        @click="messageDialog = true"
      >
        {{ feedback.replied ? formatRepliedOnDate(feedback.replied): $t('label.send_reply') }}
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="showReservation"
      >
        {{ $t('label.show_reservation') }}
      </v-btn>
      <v-spacer />
      <v-btn
        text
        color="error"
        @click="close"
      >
        {{ $t('button.close') }}
      </v-btn>
    </template>
  </new-modal-dialog>
</template>

<script setup lang="ts">
/* eslint-disable object-curly-newline */
import i18n from '@/plugins/i18n';
import localized from '@/plugins/vue-localized-formatter/src/localized';
import ContactMessageDialog from '@/components/views/reservation/ContactMessageDialog.vue';

import NewModalDialog from '@/components/dialogs/NewModalDialog.vue';
import { ref, PropType, computed, onMounted } from 'vue';
import Feedback from '@/grpc-api/model/feedback';

import FeedbackRatingChip from '@/components/views/feedback/FeedbackRatingChip.vue';
import { tryEditReservation } from '@/services/reservation-edit-utils';
import router from '@/router';
import { performDispatchAction } from '@/services/vue-utils';

const emit = defineEmits(['close']);

const props = defineProps({
  feedback: { type: Object as PropType<Feedback>, required: true },
});

const reservation = computed(() => props.feedback.reservation);

const messageDialog = ref(false);

const formatRepliedOnDate = (d: Date) => i18n.t('label.reply_sent_on_x', [localized.dateText(d)!]);

const close = () => emit('close');

const showReservation = async () => {
  const { reservationId } = props.feedback;
  const changeToDate = props.feedback.reservationDtBegin;
  if (reservationId && changeToDate) tryEditReservation(router, reservationId, {}, { changeToDate });
  close();
};

const closeMessageDialog = async (res: boolean | undefined) => {
  if (res && props.feedback) {
    await performDispatchAction('getFeedback', { id: props.feedback.id }) as Feedback | undefined;
  }

  messageDialog.value = false;
};

</script>
